interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/** Hidden field that catches bots. Real users never see or fill this. */
const HoneypotField = ({ value, onChange }: HoneypotFieldProps) => (
  <div
    aria-hidden="true"
    style={{
      position: "absolute",
      left: "-9999px",
      top: "-9999px",
      opacity: 0,
      height: 0,
      width: 0,
      overflow: "hidden",
      pointerEvents: "none",
    }}
  >
    <label htmlFor="website_url_confirm">Leave this empty</label>
    <input
      id="website_url_confirm"
      name="website_url_confirm"
      type="text"
      autoComplete="off"
      tabIndex={-1}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default HoneypotField;
